import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  return <>
      <footer className="bg-charcoal py-12" data-id="element-89">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-90">
          <div className="text-center" data-id="element-91">
            <p className="font-serif text-2xl text-white mb-4" data-id="element-92">
              CÓDIGO HORMONAL 40+
            </p>
            <p className="text-white text-sm" data-id="element-93">
              © 2026 Código Hormonal 40+. Todos los derechos reservados.
            </p>
            <p className="text-white text-xs mt-4 max-w-2xl mx-auto" data-id="element-94">
              Este producto no pretende diagnosticar, tratar, curar o prevenir
              ninguna enfermedad. Consulta con tu médico antes de comenzar
              cualquier programa de nutrición o ejercicio.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-6 text-sm" data-id="element-95">
              <button onClick={() => setOpenModal('privacy')} className="text-white hover:text-gold transition-colors underline-offset-4 hover:underline" data-id="element-96">
                Política de Privacidad
              </button>
              <span className="text-white/40" aria-hidden="true" data-id="element-97">
                •
              </span>
              <button onClick={() => setOpenModal('terms')} className="text-white hover:text-gold transition-colors underline-offset-4 hover:underline" data-id="element-98">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-99">
        {openModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/70 backdrop-blur-sm" onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-100">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-warm-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-101">
              <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-charcoal/10" data-id="element-102">
                <h3 id="modal-title" className="font-serif text-2xl md:text-3xl text-charcoal" data-id="element-103">
                  {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
                </h3>
                <button onClick={closeModal} aria-label="Cerrar" className="text-charcoal/60 hover:text-charcoal transition-colors p-1 rounded-md hover:bg-charcoal/5" data-id="element-104">
                  <XIcon className="w-6 h-6" data-id="element-105" />
                </button>
              </div>

              <div className="overflow-y-auto px-6 md:px-8 py-6 text-charcoal/80 text-sm md:text-base leading-relaxed space-y-4" data-id="element-106">
                {openModal === 'privacy' ? <>
                    <p data-id="element-107">
                      En Código Hormonal 40+ respetamos y protegemos tu
                      privacidad. Esta política describe cómo recopilamos,
                      usamos y protegemos tu información personal.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-108">
                      1. Información que Recopilamos
                    </h4>
                    <p data-id="element-109">
                      Recopilamos información que nos proporcionas directamente,
                      como tu nombre, correo electrónico y datos de pago al
                      realizar una compra.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-110">
                      2. Uso de la Información
                    </h4>
                    <p data-id="element-111">
                      Utilizamos tu información para procesar pedidos, enviarte
                      el acceso al programa, brindar soporte y enviarte
                      comunicaciones relevantes sobre tu compra.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-112">
                      3. Protección de Datos
                    </h4>
                    <p data-id="element-113">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información contra acceso
                      no autorizado, alteración o destrucción.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-114">
                      4. Tus Derechos
                    </h4>
                    <p data-id="element-115">
                      Tienes derecho a acceder, rectificar o eliminar tus datos
                      personales en cualquier momento. Contáctanos para ejercer
                      estos derechos.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-116">
                      5. Contacto
                    </h4>
                    <p data-id="element-117">
                      Si tienes preguntas sobre esta política, por favor
                      contáctanos a través de nuestro correo de soporte.
                    </p>
                  </> : <>
                    <p data-id="element-118">
                      Al adquirir y utilizar Código Hormonal 40+, aceptas los
                      siguientes términos y condiciones. Por favor léelos
                      cuidadosamente.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-119">
                      1. Naturaleza del Producto
                    </h4>
                    <p data-id="element-120">
                      Código Hormonal 40+ es un programa educativo de bienestar.
                      No sustituye el consejo médico profesional. Consulta con
                      tu médico antes de iniciar cualquier programa de nutrición
                      o ejercicio.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-121">
                      2. Acceso al Programa
                    </h4>
                    <p data-id="element-122">
                      Al completar tu compra, recibirás acceso digital inmediato
                      al programa y todos los bonos incluidos. El acceso es
                      personal e intransferible.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-123">
                      3. Garantía de Reembolso
                    </h4>
                    <p data-id="element-124">
                      Ofrecemos una garantía de devolución de 60 días. Si no
                      estás satisfecha, escríbenos dentro de ese plazo y te
                      reembolsaremos el 100% de tu compra.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-125">
                      4. Propiedad Intelectual
                    </h4>
                    <p data-id="element-126">
                      Todo el contenido del programa está protegido por derechos
                      de autor. Queda prohibida su reproducción, distribución o
                      reventa sin autorización expresa.
                    </p>
                    <h4 className="font-serif text-lg text-charcoal mt-4" data-id="element-127">
                      5. Resultados
                    </h4>
                    <p data-id="element-128">
                      Los resultados pueden variar de una persona a otra.
                      Ninguna garantía específica de resultados es ofrecida más
                      allá de la política de reembolso.
                    </p>
                  </>}
              </div>

              <div className="px-6 md:px-8 py-4 border-t border-charcoal/10 bg-cream/50" data-id="element-129">
                <button onClick={closeModal} className="w-full md:w-auto bg-forest text-warm-white px-6 py-3 rounded-md font-semibold hover:bg-forest/90 transition-colors" data-id="element-130">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}